import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { useCurrentUserRole } from '../../shared/session/useCurrentUserRole';
import { getDefaultRouteForRole } from './routeManifest';
import { usesCentralIdentity } from '../../features/auth/sessionAccess';
import TenantAccessRejected, {
  isTenantAccessRejection,
} from '../../features/auth/components/TenantAccessRejected';

export function ProtectedRoute({ children, requiredRole, requiredRoles }) {
  const { isAuthenticated, initialized } = useAuth();
  const {
    data: userRole,
    error: roleError,
    isLoading: isRoleLoading,
  } = useCurrentUserRole({ enabled: isAuthenticated });
  const location = useLocation();

  if (isAuthenticated && usesCentralIdentity() && isTenantAccessRejection(roleError)) {
    return <TenantAccessRejected />;
  }

  if (!initialized || (isAuthenticated && isRoleLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-400" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowedRoles = Array.isArray(requiredRoles)
    ? requiredRoles
    : requiredRole
      ? [requiredRole]
      : null;

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to={getDefaultRouteForRole(userRole)} replace />;
  }

  return children;
}
